import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import Iconify from "../../../../../minimals/components/iconify";
import useResponsive from "../../../../../minimals/hooks/useResponsive";

export default function OrdersFilter({
  statuses,
  selectedStatus,
  onStatusChange
}: {
  statuses: string[];
  selectedStatus: string;
  onStatusChange: (status: string) => void;
}) {
  const isMobile = useResponsive("down", "md");

  return (
    <>
      <Autocomplete
        size={isMobile ? "small" : "medium"}
        sx={{ width: { xs: 140, md: 160 }, marginRight: { xs: 0, md: 2 } }}
        defaultValue="All"
        value={selectedStatus}
        options={statuses}
        onChange={(e, v) => v && onStatusChange(v)}
        renderInput={(params) => <TextField {...params} size={isMobile ? "small" : "medium"} label="Status" />}
      />
      {/*<TextField*/}
      {/*  InputProps={{*/}
      {/*    startAdornment: (*/}
      {/*      <InputAdornment position="start">*/}
      {/*        <Iconify icon="eva:search-fill" />*/}
      {/*      </InputAdornment>*/}
      {/*    ),*/}
      {/*  }}*/}
      {/*  placeholder="Search..."*/}
      {/*  sx={{ width: 368 }}*/}
      {/*/>*/}
    </>
  );
}
